import * as React from "react";
import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useParams,
  useRouteMatch,
} from "react-router";

import { DetailLayoutWrapper } from "../../components/sharedStyles";
import { buildQueryString } from "../../store/base";

import DetailPageHeaderMenu from "../Layouts/DetailPageHeaderMenu/DetailPageHeaderMenu";
import { useFilteredCompanies } from "../../store/companies";
import { useDispatch } from "react-redux";
import { getAllInvoices, getAllPayments } from "../../store/billectaInvoicing";
import PaymentsContainer from "../../components/Billecta/Payments/PaymentsContainer";
import Search from "./detail/Search";
import AccountsReceivable from "./detail/AccountsReceivable";
import InvoicingContracts from "./detail/Contracts";
import Invoices from "./detail/Invoices";
import BillectaKyc from "./detail/Kyc";
import { clearIntegrationData } from "../../store/billectaIntegrations";
import Notifications from "./detail/Notifications";
import VacancyBookings from "./detail/VacancyBookings";
import PrimaryBtn from "../../components/Forms/Base/Buttons/PrimaryBtn";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

function BillectaDetail() {
  const dispatch = useDispatch();
  const { path, url } = useRouteMatch();
  const { push } = useHistory();

  const { creditorId } = useParams();

  React.useEffect(() => {
    dispatch(getAllInvoices(creditorId));
    dispatch(getAllPayments(creditorId));
  }, [creditorId]);

  React.useEffect(() => {
    return () => {
      dispatch(clearIntegrationData());
    };
  }, []);

  const companyQuery = buildQueryString({
    billecta_id: creditorId,
  });

  const [companies, isLoadingCompany] = useFilteredCompanies(companyQuery);
  const company = companies?.[0];

  const SUB_PAGES = [
    {
      path: "/overview",
      label: "Översikt",
      component: Notifications,
    },
    {
      path: "/invoices",
      label: "Fakturor",
      component: Invoices,
    },
    {
      path: "/vacancy-bookings",
      label: "Vakansbokningar",
      component: VacancyBookings,
    },
    {
      path: "/contract-invoices",
      label: "Avtal",
      component: InvoicingContracts,
    },
    {
      path: "/payments",
      label: "Betalningar",
      component: PaymentsContainer,
    },
    {
      path: "/search",
      label: "Sök",
      component: Search,
    },
    {
      path: "/accounts-receivable",
      label: "Kundreskontra",
      component: AccountsReceivable,
    },
  ];

  if (company && !company?.kyc_report?.id) {
    SUB_PAGES.push({
      path: "/kyc",
      hidden: true,
      component: BillectaKyc,
    });
  }

  const subPageLinks = SUB_PAGES.filter((s) => !s.hidden).map((sp) => ({
    url: `${url}${sp.path}`,
    label: sp.label,
    hasError: sp.hasError,
  }));

  const renderActions = () => {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {company && !company?.kyc_report?.id && (
          <PrimaryBtn secondary onClick={() => push(`${url}/kyc`)}>
            <ExclamationCircleIcon width={16} className="mr-1" /> Registrera KYC
          </PrimaryBtn>
        )}
      </div>
    );
  };

  return (
    <>
      <DetailLayoutWrapper>
        <DetailPageHeaderMenu
          title={
            company?.str_representation
              ? `Hyresavisering för ${company?.str_representation}`
              : "Laddar..."
          }
          {...{
            subPages: subPageLinks,
            breadCrumbs: [
              {
                label: "Hyresavisering",
                url: "/rental-notifications",
              },
              { label: company?.str_representation || "Laddar..." },
            ],
            renderActions,
          }}
        />

        <Switch>
          {SUB_PAGES.map((sp) => (
            <Route
              key={sp.path}
              path={`${path}${sp.path}`}
              component={sp.component}
            />
          ))}

          {/* Default sub page  */}
          <Redirect exact to={`${url}${SUB_PAGES[0].path}`} path={`${path}`} />
        </Switch>
      </DetailLayoutWrapper>
    </>
  );
}

export default BillectaDetail;
